import type { OverviewState } from '../../types.ts';
import { TableName } from './constants.ts';

export const getBiverkningSubTableSelector = (state: OverviewState) => state.data.present.getSubTable(TableName);
